import * as Models from '~/models/tenders';
import * as api from '~/fetch';
import { loadable } from '~/observable';

type TenderId = Partial<Record<'tenderId', string>>;
type Loader<T> =
  | { loading: true; errors: string[]; data?: undefined }
  | {
      loading: false;
      errors: string[];
      data: T;
    };

export function tenderReport() {
  return loadable<Loader<Models.TenderReport>, TenderId>(
    async (onChange, { tenderId = '' } = {}) => {
      onChange({ loading: true as const, errors: [], data: undefined });

      try {
        const response = await api.tenders.reports(tenderId);
        await api.utils.processResponse(response, {
          async 200(response) {
            const data = await response.json();
            onChange({
              loading: false as const,
              errors: [],
              data: new Models.TenderReport(data),
            });
          },
          async default() {
            onChange({
              loading: true as const,
              errors: ['There was an error'],
              data: undefined,
            });
          },
        });
      } catch (error) {
        console.error('tender-analytics-report: Unknown error', error);
        onChange({
          loading: true as const,
          errors: ['There was an error'],
          data: undefined,
        });
      }
    }
  );
}

export function counterHistory() {
  return loadable<Loader<Models.TenderCharts>, TenderId>(
    async (onChange, { tenderId = '' } = {}) => {
      onChange({ loading: true as const, errors: [], data: undefined });

      try {
        const response = await api.tenders.reportCounterHistory(tenderId);
        await api.utils.processResponse(response, {
          async 200(response) {
            const data = await response.json();
            onChange({
              loading: false as const,
              errors: [],
              data: new Models.TenderCharts({ history: data, frequency: [] }),
            });
          },
          async default() {
            onChange({
              loading: true as const,
              errors: ['There was an error'],
              data: undefined,
            });
          },
        });
      } catch (error) {
        console.error('tender-analytics-report: Unknown error', error);
        onChange({
          loading: true as const,
          errors: ['There was an error'],
          data: undefined,
        });
      }
    }
  );
}
